<template>
  <YaTeLaw />
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import YaTeLaw from '~/components/YaTe/YaTeLaw/YaTeLaw.vue'

const options = {
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',
    })
    return {
      title:
        'LINEヤフーテックアカデミー特定商取引法に関する表示 | テックアカデミー',
      meta: [
        ...metaTags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            description: 'LINEヤフーテックアカデミーの特定商取引法に関する表示',
            twitterTitle:
              'LINEヤフーテックアカデミー特定商取引法に関する表示 | テックアカデミー',
            twitterDescription:
              'LINEヤフーテックアカデミーの特定商取引法に関する表示',
            twitterImage: '/_nuxt/ogp/yate/og-image.jpg',
            ogDescription:
              'LINEヤフーテックアカデミーの特定商取引法に関する表示',
            ogTitle:
              'LINEヤフーテックアカデミー特定商取引法に関する表示 | テックアカデミー',
            ogUrl: '/yahoo/law',
            ogImage: '/_nuxt/ogp/yate/og-image.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    YaTeLaw,
  },
  async setup() {
    definePageMeta({
      layout: 'yate-side-menu'
    })
  },
}

export default defineNuxtComponent(options)
</script>

